module.exports = __webpack_public_path__ + "img/BINANCE_COIN_BSC.0ec3a3b0.svg";